import React from 'react'

export default function Row(props) {
  const { className, style, testId, children, ...restProps } = props
  return (
    <div
      className={'table-row ' + (className || '')}
      style={style || {}}
      data-testid={testId || ''}
      {...restProps}
    >
      {children}
    </div>
  )
}
